module.exports = "h1, h2{\r\n\tfont-weight: bold;\r\n}\r\nh2, h3{\r\n\tfont-size: 0.9em;\r\n\tmargin: 0;\r\n\ttext-align: center;\r\n}\r\nh3{\r\n\tmargin-bottom: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/diretoria-internacional/diretoria-internacional.component.css
// module id = ./src/app/diretoria-internacional/diretoria-internacional.component.css
// module chunks = main